<i18n src="@/locales/components/WatchersTranslate.json"></i18n>

<template>
	<div class="watcher-config">
		<!-- Block tag employee, departement, title -->
		<div class="">
			<cbs-relations-humanroles
				class="my-4"
				name="assignees"
				v-model="localWatcher.relations"
				:type="1"
				:close-on-select="false"
				:title="$t('Watcher')"
				:placeholder="$t('Input.InputWatcher')"
			/>
		</div>

		<!-- Due time -->
		<div v-if="localWatcher.relations && localWatcher.relations.length" class="due-time-container my-4">
			<h6 class="mb-2 custom-component--title">{{ $t("DueTime") }}<span class="text-danger">*</span>:</h6>
			<div class="due-time-content bg-white">
				<div class="flex items-stretch ">
					<v-select class="border-none w-1/3 " v-model="localWatcher.remind_unit" :clearable="false" :options="dueUnits" :reduce="unit => unit.value"> </v-select>

					<cbs-input
						min="0"
						class="w-2/3"
						dataType="int"
						v-validate="{
							required: true,
							min_value: 0,
							regex: '^[0-9]\\d*$'
						}"
						v-model="localWatcher.remind_value"
						:name="`${formName}-remind`"
						:data-vv-as="$t('DueTime')"
						:placeholder="$t('Input.InputDueTime')"
					/>
				</div>
			</div>
			<span class="text-danger text-sm break-normal" v-show="errors.has(`${formName}-remind`)">{{ errors.first(`${formName}-remind`) }}</span>
		</div>
		<!-- Block Notification content -->
		<div class="my-4" v-if="localWatcher.relations && localWatcher.relations.length">
			<label for class="vs-input--label">{{ $t("NotificationContent") }}<span class="text-danger">*</span>:</label>
			<cbs-editor
				data-vv-delay="100"
				v-validate="'required'"
				class="bg-white normal-placeholder"
				v-model="localWatcher.content"
				:name="`${formName}-content`"
				:data-vv-as="$t('NotificationContent')"
				:placeholder="$t('Input.InputNotificationContent')"
				:mentionType="$constant.TEMPLATE_VARIABLES.TODO_WATCHER_CONTENT"
			/>
			<span class="text-danger text-sm break-normal" v-show="errors.has(`${formName}-content`)">{{ errors.first(`${formName}-content`) }}</span>
		</div>
		<!-- Toggle permission modify mission -->
		<div class="flex items-center justify-between">
			<div class="flex">
				<vs-switch color="success mr-4" v-model="localWatcher.can_edittable" />
				<span>{{ $t("PermissionModify") }}</span>
			</div>
			<vs-button radius type="flat" class="p-0" color="primary" icon-pack="nucleo" icon="nucleo-trash-can" @click="$emit('onClickDelete', localWatcher)"></vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";
import vSelect from "vue-select";

import CbsEditor from "@/components/cbs-editor/CbsEditor";

const isValidWatcherData = watcher => _.has(watcher, "content") && _.has(watcher, "relations") && _.has(watcher, "remind_unit") && _.has(watcher, "remind_value") && _.has(watcher, "can_edittable");

export default {
	name: "WatcherConfig",
	inject: ["parentValidator"],
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => isValidWatcherData(prop)
		},
		formName: {
			type: String,
			default: "watcher-config"
		}
	},
	emits: {
		onClickDelete: {}
	},
	components: {
		vSelect,
		CbsEditor
	},
	data() {
		return {
			dueUnits: [
				{ label: this.$t("TypeRepeater.Days"), value: "day" },
				{ label: this.$t("TypeRepeater.Hour"), value: "hour" }
			]
		};
	},
	computed: {
		localWatcher: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss">
.watcher-config {
	padding: 25px;
	border-radius: 4px;
	background: #f8f8f8;
}
</style>
